import React from "react";
import styled from "styled-components";

import Text from "../Text";
import documentToReactComponents from "../../util/documentToReactComponents";

import theme from "../../../styles/theme";
import HTMLWrapper from "../HTMLWrapper";

const {
	font,
	section,
	colors,
	breakPoints: { screenQuery, mobileFirstScreenQuery },
} = theme;

const Container = styled.div`
	z-index: 1;
	background: ${(props) =>
		props.backgroundColor
			? props.backgroundColor
			: props.complexGradient
			? props.complexGradient
			: props.gradient
			? `linear-gradient(${props.gradient})`
			: "transparent"};
	overflow: ${(props) => (props.showOverflow ? "visible" : "hidden")};
	${(props) => props.containerStyles}
	${(props) => (props.backgroundImage ? `background-image: url(${props.backgroundImage}); background-size: cover;` : "")}
`;

const Section = styled.div`
	margin: 0 auto;
	width: ${(props) => (props.nestedSection ? "100%" : "90%")};
	max-width: ${(props) => (props.maxWidth ? props.maxWidth : "1100px")};

	padding: ${(props) => (props.topBottomSpace ? props.topBottomSpace : section.topBottomSpace)} 0px;
	${(props) => (props.noBottomPadding ? `padding-bottom: 0px !important;` : null)}
	${(props) => (props.noTopPadding ? `padding-top: 0px !important;` : null)}
    .center-button {
		display: block;
		max-width: 330px;
		margin: 0 auto;
		margin-top: 75px;
	}

	${screenQuery.medium} {
		padding: ${(props) => (props.topBottomSpace ? props.topBottomSpace : "80px")} 0px;
	}
`;
const Header = styled.div`
	padding-bottom: 60px;
	text-align: ${(props) => (props.centerHeader ? "center" : "left")};
	${(props) => (props.noHeaderPadding ? `padding-bottom: 0;` : "")};

	${mobileFirstScreenQuery.large} {
		max-width: ${(props) => props.maxHeaderWidth || "60vw"};
		margin: 0 auto;
	}

	h2,
	p {
		text-align: ${(props) => (props.centerHeader ? "center" : "left")};
	}
`;
export const Overline = styled(Text)`
	font-family: ${font.bold};
	font-size: 13px;
	line-height: 13px;
	color: ${colors.newBrand.coolGrey};
	letter-spacing: 0.2em;
	text-transform: uppercase;
	margin-bottom: 20px;

	p {
		color: ${colors.newBrand.coolGrey};
	}
`;

export default ({
	children,
	className,
	maxWidth,
	backgroundColor,
	backgroundImage,
	gradient,
	complexGradient,
	topBottomSpace,
	noTopPadding,
	noBottomPadding,
	id,
	showOverflow,
	overline,
	header,
	subheader,
	subheaderRaw,
	subheaderHTML,
	centerHeader,
	maxHeaderWidth,
	noHeaderPadding,
	nestedSection,
	containerStyles,
}) => {
	return (
		<Container
			showOverflow={showOverflow}
			id={id}
			backgroundColor={backgroundColor}
			backgroundImage={backgroundImage}
			gradient={gradient}
			complexGradient={complexGradient}
			containerStyles={containerStyles}
			className="section__container"
		>
			<Section
				topBottomSpace={topBottomSpace}
				className={className}
				maxWidth={maxWidth}
				noTopPadding={noTopPadding}
				noBottomPadding={noBottomPadding}
				nestedSection={nestedSection}
			>
				{header && (
					<Header
						className="section-header"
						noHeaderPadding={noHeaderPadding}
						maxHeaderWidth={maxHeaderWidth}
						centerHeader={centerHeader}
					>
						{overline && (
							<Overline component="caps" className="overline">
								{overline}
							</Overline>
						)}
						<Text component="h2">{header}</Text>
						{subheader && <Text component="b2" className="section-subheader">{subheader}</Text>}
						{subheaderRaw && <Text component="b2" className="section-subheader">{documentToReactComponents(subheaderRaw)}</Text>}
						{subheaderHTML && (
							<Text component="b2" className="section-subheader">
								<HTMLWrapper html={subheaderHTML} />
							</Text>
						)}
					</Header>
				)}
				{children}
			</Section>
		</Container>
	);
};
